export const Login = '/';
export const SignUp = '/accounts/signup';
export const Dashboard = '/user-dashboard';
export const Error404 = 'Error-404';
export const Explore = '/explore';
export const ExplorePost = '/explore/user/post';
export const PostPage = `/post`; // + /postId
export const ProfilePage = `/profile`;
export const NewPostPage = `/new`;
export const SettingsPage = '/settings/edit';
export const ForgotPassword = "/forgotpassword";
